
import {defineComponent} from "vue";

export default defineComponent({
    name: 'Rating',
    props: {
        average: {
            type: Number,
            required: true
        },
        text: {
            type: String,
            default: null
        },
        link: {
            type: String,
            default: null
        },
        // taille de police en rem
        ratingResultsHeight: {
            type: Number,
            required: true
        },
        // taille de police note en rem
        fontSize: {
            type: Number,
            required: false,
            default: null
        }
    },
    computed: {
        roundedAverage() {
            if (Math.round(this.average) === this.average) {
                return this.average
            }
            return this.average.toFixed(1)
        },
        formattedAverage() {
            return this.roundedAverage.toString().replace('.', ',')
        },
        ob1RatingStyle() {
            return '--rating-results-height: ' + this.ratingResultsHeight + 'rem;'
        },
        ob1ScoreStyle() {
            return this.fontSize ? 'font-size: ' + this.fontSize + 'rem;' : ''
        },
        title() {
            if (this.withScore) return null;
            else return this.roundedAverage + ' sur 5';
        }
    },
    methods: {
        clickHandler(event: Event) {
            this.$emit('ob1-rating-link', event);
        }
    }
});
